<div class="modal-content">
  <div class="modal-header">
    <p class="modal-title font-16 mb-0 text-dark">
      <span *ngIf="!bonus || isAttendanceBonus">{{ 'employees_bonuses.page_title_create' | translate }}</span>
      <span *ngIf="bonus && !isAttendanceBonus">{{ 'employees_bonuses.page_title_edit' | translate }}</span>
    </p>
    
    <button
        (click)="activeModal.dismiss()"
        aria-label="Close"
        class="close"
    >
      <span
          aria-hidden="true"
          class="font-24 text-muted"
      >
        <i class="mdi mdi-close"></i>
      </span>
    </button>
  </div>
  
  <div class="modal-body">
    <div class="row">
      <div class="col-md-12">
        <div class="card mb-0 shadow-none">
          <div class="card-body p-0">
            <form
                (ngSubmit)="onSubmit()"
                [formGroup]="bonusEditForm"
                autocomplete="off"
            >
              <div class="row">
                <div class="col-lg-12">
                  <div class="form-group">
                    <label class="control-label">
                      <span>{{ 'employees_bonuses.name' | translate }}</span>
                    </label>
                    
                    <input
                        class="form-control"
                        formControlName="name"
                        name="name"
                        type="text"
                    >
                    
                    <div *ngIf="submitted && f.name.errors">
                      <p
                          *ngIf="f.name.errors.required"
                          class="text-danger validation-text"
                      >
                        <span>{{ 'angular_validation.field' | translate }} </span>
                        <span>{{ 'employees_bonuses.name' | translate }} </span>
                        <span>{{ 'angular_validation.required' | translate }}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              
              <app-lookup-select [controlName]="'type'"
                                 [formGroup]="bonusEditForm"
                                 [multiple]="false"
                                 [submitted]="submitted"
                                 [type]="'bonus_type'">
              </app-lookup-select>
              
              <div class="row">
                <div class="col-lg-12">
                  <div class="form-group">
                    <label class="control-label">
                      <span>{{ 'employees_bonuses.date' | translate }}</span>
                    </label>
                    
                    <input
                        [allowInput]="true" [altInput]="true"
                        [disableMobile]="true"
                        [locale]="locale$ | async"
                        altFormat="d.m.Y"
                        class="form-control"
                        dateFormat="Y-m-d"
                        formControlName="date"
                        mwlFlatpickr
                        name="date"
                        type="text"
                    >
                    
                    <div *ngIf="submitted && f.date.errors">
                      <p
                          *ngIf="f.date.errors.required"
                          class="text-danger validation-text"
                      >
                        <span>{{ 'angular_validation.field' | translate }} </span>
                        <span>{{ 'employees_bonuses.date' | translate }} </span>
                        <span>{{ 'angular_validation.required' | translate }}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              
              <div class="row">
                <div class="col-lg-12">
                  <div class="form-group">
                    <label class="control-label">
                      <span>{{ 'employees_bonuses.amount' | translate }}</span>
                    </label>
                    
                    <div [ngClass]="{'hidden-sensitive-value-input': hiddenInputs}">
                      <input [options]="{ allowNegative: true, inputMode: 0 }" class="form-control" currencyMask formControlName="amount" name="amount" type="text">
                    </div>
                    
                    <div *ngIf="submitted && f.amount.errors">
                      <p
                          *ngIf="f.amount.errors.required"
                          class="text-danger validation-text"
                      >
                        <span>{{ 'angular_validation.field' | translate }} </span>
                        <span>{{ 'employees_bonuses.amount' | translate }} </span>
                        <span>{{ 'angular_validation.required' | translate }}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              
              <div class="row">
                <div class="col-lg-12">
                  <div class="form-group">
                    <label class="control-label">
                      <span>{{ 'employees_bonuses.note' | translate }}</span>
                    </label>
                    
                    <input
                        class="form-control"
                        formControlName="note"
                        name="note"
                        type="text"
                    >
                  </div>
                </div>
              </div>
              
              <app-custom-fields [columns]="1"
                                 [customFields]="bonus?.custom_fields"
                                 [fieldset]="false"
                                 [form]="bonusEditForm"
                                 [hr]="true"
                                 [sensitive]="true"
                                 [submitted]="submitted"
                                 [widget]="'EMPLOYEE_BONUS'">
              </app-custom-fields>
              
              <div *ngIf="(!bonus && employee?.permissions?.createBonusWithApproval) || (bonus && (employee?.permissions?.editBonusWithApproval || employee?.permissions?.deleteBonusWithApproval))"
                   class="row">
                <div class="col-12 text-right">
                  <p class="text-muted mb-1"><small> {{ 'employees_addresses.request_will_be_sent' | translate }} </small></p>
                </div>
              </div>
              <div
                  class="row mt-2"
              >
                <div class="col-12 text-right">
                  <u
                      (click)="deleteBonus()"
                      *ngIf="bonus && (employee?.permissions?.deleteBonus || employee?.permissions?.deleteBonusWithApproval) && !hiddenInputs"
                      class="text-muted mr-2"
                  >{{ 'global.action_delete' | translate }}</u>
                  <button [disabled]="hiddenInputs" class="btn btn-success" type="submit">
                    <span>{{ 'global.action_save' | translate }}</span>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
